import React from "react";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { Button, Modal, Table } from "antd";
import { useNavigate } from "react-router-dom";
import {
  ErrorToast,
  SuccessToast,
  UpdatedToast,
} from "../../../views/ToastComponent";

const GarageAuto = ({ ProfileId, profileId }) => {
  const [allBusinessPd, setAllBusinessPd] = React.useState([]);
  const [areaType, setAreaType] = React.useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  // const [shopCreated, setShopCreated] = React.useState(false);

  const navigate = useNavigate();

  const [garageAutoData, setGarageAutoData] = React.useState({
    name: "",
    workingDays: 0,
    businessPdProfileId: profileId,
    latitude: "",
    longitude: "",
    profitMarginId: 0,
  });

  const handleClick = async (id) => {
    console.log("id", id);
    try {
      const response = await axios.get(`${Api_Url}api/v1/AutoGarage/${id}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      console.log("all data", response.data.data);
      setGarageAutoData(response.data.data);
      setIsEditModalOpen(true);
    } catch (error) {
      return error.message;
    }
  };

  const handleUpdate = async (id) => {
    console.log("kkk", id);
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/AutoGarage/${id}`,
        garageAutoData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("updateed", response.data);
      if (response.data.succeeded) {
        UpdatedToast("Updated successfully");
        handleCancel();
        fetchIncomeData();
      }
    } catch (error) {
      ErrorToast("something went wrong");
      return error;
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Area Type",
      dataIndex: "profitMarginName",
      sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
    },
    {
      title: "Working Day",
      dataIndex: "workingDays",
      sorter: (a, b) => a.workingDays.length - b.workingDays.length,
    },
    {
      title: "Income",
      dataIndex: "income",
      sorter: (a, b) => a.income.length - b.income.length,
    },
    {
      title: "Live Visit Income",
      dataIndex: "liveVisitIncome",
      sorter: (a, b) => a.liveVisitIncome.length - b.liveVisitIncome.length,
    },
    {
      title: "Created At",
      dataIndex: "created",
      render: (text) => {
        return (
          new Date(text).toLocaleDateString() +
          "   " +
          new Date(text).toLocaleTimeString()
        );
      },
      sorter: (a, b) => a.created.length - b.created.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <Button
          onClick={() => {
            navigate(`details/${record.id}`, {
              state: { ...record },
            });
          }}
        >
          View Details
        </Button>
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleClick(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
  ];

  const fetchIncomeData = async () => {
    const { data } = await axios.get(
      Api_Url + "api/v1/AutoGarage/getbybusinesspdprofileid/" + profileId,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
        },
      }
    );
    console.log("totalAmount", data);
    setAllBusinessPd(data);
  };

  const fetchAreaType = async () => {
    try {
      const { data } = await axios.get(
        Api_Url + "api/v1/ProfitMargin/getbyprofileid/" + ProfileId,
        {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user"))?.accessToken,
          },
        }
      );
      setAreaType(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setGarageAutoData((prev) => ({
          ...prev,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        }));
      });
    } else {
      return "Geolocation is not supported by this browser.";
    }
  };

  // Submitting the Data
  const handleSubmit = async () => {
    let response;
    try {
      response = await axios.post(
        Api_Url + "api/v1/AutoGarage",
        garageAutoData,
        {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user"))?.accessToken,
          },
        }
      );
      if (response.data.succeeded) {
        SuccessToast("Created Successfully");
        // setShopCreated(true);
        handleCancel();
        fetchIncomeData();
      }
    } catch (error) {
      ErrorToast("Something Went wrong");
      console.log(error);
    }
  };

  React.useEffect(() => {
    fetchIncomeData();
    fetchAreaType();
    fetchCurentLocation();
  }, []);

  async function handleCancel() {
    setGarageAutoData({
      ...garageAutoData,
      name: "",
      workingDays: 0,
      businessPdProfileId: profileId,
      latitude: "",
      longitude: "",
      profitMarginId: 0,
    });
    setIsModalOpen(false);
    setIsEditModalOpen(false);
  }

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-between">
          <h3 className="mb-0">Auto Garage</h3>
          { allBusinessPd.length === 0 && (
            <button
              className="btn btn-primary submit-btn"
              onClick={() => setIsModalOpen(true)}
            >
              Add Auto Garage
            </button>
          )}
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12 mx-auto">
          <Table
            className="table-striped"
            style={{ overflowX: "auto" }}
            columns={columns}
            dataSource={allBusinessPd}
            rowKey={(record) => record.id}
          />
        </div>
      </div>

      {/* Garage Auto Form */}
      <Modal
        title={<h4>Add Garage Auto</h4>}
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button
              key="Cancel"
              className="btn btn-danger submit-btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            ,
            <button
              key="submit"
              className="btn btn-primary submit-btn"
              type="submit"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>,
        ]}
        width={600}
        masked={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Name of Garage</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Garage Name"
                    value={garageAutoData.name}
                    onChange={(event) =>
                      setGarageAutoData((prev) => ({
                        ...prev,
                        name: event.target.value,
                      }))
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Total Working Day(in Month)
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Working Day"
                    value={garageAutoData.workingDays}
                    onChange={(event) =>
                      setGarageAutoData((prev) => ({
                        ...prev,
                        workingDays: event.target.value,
                      }))
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Area Type
                  </label>
                  <select
                    id="vehicleType"
                    className="custom-select-style"
                    value={garageAutoData.profitMarginId}
                    onChange={(event) =>
                      setGarageAutoData((prev) => ({
                        ...prev,
                        profitMarginId: event.target.value,
                      }))
                    }
                  >
                    <option value={0} selected>
                      Select Vehicle Type
                    </option>
                    {areaType.length > 0 &&
                      areaType.map((area) => (
                        <option value={area.id}>{area.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      {/* Edit Modal */}

      <Modal
        title={<h4>Add Garage Auto</h4>}
        open={isEditModalOpen}
        centered
        onOk={() => setIsEditModalOpen(false)}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button
              key="Cancel"
              className="btn btn-danger submit-btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            ,
            <button
              key="submit"
              className="btn btn-primary submit-btn"
              type="submit"
              onClick={() => handleUpdate(garageAutoData.id)}
            >
              Submit
            </button>
          </div>,
        ]}
        width={600}
        masked={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Name of Garage</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Garage Name"
                    value={garageAutoData.name}
                    onChange={(event) =>
                      setGarageAutoData((prev) => ({
                        ...prev,
                        name: event.target.value,
                      }))
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Total Working Day(in Month)
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Working Day"
                    value={garageAutoData.workingDays}
                    onChange={(event) =>
                      setGarageAutoData((prev) => ({
                        ...prev,
                        workingDays: event.target.value,
                      }))
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Area Type
                  </label>
                  <select
                    id="vehicleType"
                    className="custom-select-style"
                    value={garageAutoData.profitMarginId}
                    onChange={(event) =>
                      setGarageAutoData((prev) => ({
                        ...prev,
                        profitMarginId: event.target.value,
                      }))
                    }
                  >
                    <option value={0} selected>
                      Select Vehicle Type
                    </option>
                    {areaType.length > 0 &&
                      areaType.map((area) => (
                        <option value={area.id}>{area.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default GarageAuto;
